<template>
   <b-container>
      <table class="table stock-sheet">
         <thead>
         <tr>
            <th></th>
            <th class="text-center" v-bind:key="idx"
                v-for="(opt, idx) in colorSizeMatrix[Object.keys(colorSizeMatrix)[0]].sizeOptions">
               {{ opt.label }}
            </th>
         </tr>
         </thead>
         <tbody>
         <tr v-bind:key="variantKey.id"
             v-for="(variantKey) in Object.keys(colorSizeMatrix)">
            <td>
               <img class="variant-thumbnail"
                    :title="colorSizeMatrix[variantKey].color"
                    v-if="colorSizeMatrix[variantKey].thumbnail"
                    :src="fileResourceUrl(colorSizeMatrix[variantKey].thumbnail)"
                    alt="image"/><span
                v-else>{{ colorSizeMatrix[variantKey].color }}</span>
               <span v-if="colorSizeMatrix[variantKey].nos" class="pl-2 icon-nos"></span>
               <span v-if="colorSizeMatrix[variantKey].hasOekoTex" class="pl-2 icon-oeko-tex"></span>

            </td>
            <td v-bind:key="sizeIdx" class="text-center"
                v-for="(sizeCol, sizeIdx) in colorSizeMatrix[variantKey].sizeOptions">
               <a @click="$emit('select-variant', colorSizeMatrix[variantKey].id, sizeCol.id)"
                  v-bind:class="[{ 'text-danger': sizeCol.stock <= 0 }]">
                  {{ sizeCol.stock }}<br><span v-if="sizeCol.nos === true" class="icon-nos"></span>
               </a>
            </td>
         </tr>
         </tbody>
      </table>
   </b-container>
</template>
<script>

export default {
   props: {
      colorSizeMatrix: {
         type: Array,
         default: () => []
      }
   }
}
</script>

<style lang="scss" scoped>

@import "~@shared/_assets/scss/constants";

table.stock-sheet {
   font-size: 13px;

   thead {
      th, td {
         border-top: none;
      }
   }

   .variant-thumbnail {
      width: 45px;
      height: 45px;
      object-fit: contain;
      margin: auto;
   }
}
</style>